<!-- components/BlockTimestamp.svelte -->
<script>
    import { format as formatDate } from "date-fns";

    export let createdAt;

    // Format the creation time of the block
    function formatBlockTime(timestamp) {
        if (!timestamp) return "";

        try {
            const date = new Date(timestamp);
            return formatDate(date, "h:mm a"); // Format as "1:23 PM"
        } catch (e) {
            return "";
        }
    }
</script>

<div class="timestamp">
    {formatBlockTime(createdAt)}
</div>

<style>
    .timestamp {
        flex: 0 0 60px;
        padding: 10px 5px;
        font-size: 12px;
        color: #888;
        text-align: right;
        padding-right: 10px;
    }
</style>
